import { render, staticRenderFns } from "./section-banner.vue?vue&type=template&id=0887012a&scoped=true&"
import script from "./section-banner.vue?vue&type=script&lang=js&"
export * from "./section-banner.vue?vue&type=script&lang=js&"
import style0 from "./section-banner.vue?vue&type=style&index=0&id=0887012a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887012a",
  null
  
)

export default component.exports